export class SimpleUserForm {
    email = '';
    phone = '';
    firstName = '';
    lastName = "";
    id = 0;
}